export const constant={
    baseUrl:'https://techlabbusiness.com/techlab-admin/api/TechLabApi/'
    // baseUrl:'https://www.7timer.info/bin/'
}